module.exports = __webpack_public_path__ + "img/added-service-unit-01.2fe25f4c.png";